import { Link as ReactRouterLink } from 'react-router-dom';

import {
  Text,
  Button,
  Tag,
  TagLeftIcon,
  TagLabel,
  LinkBox,
} from '@chakra-ui/react';
import { FaCheckCircle, FaPen } from 'react-icons/fa';
import { removeHtmlTags } from 'utils/textParser';

export default [
  {
    name: 'Id',
    selector: (row) => row.id,
    sortable: true,
    width: '60px',
    sortField: 'id',
  },
  {
    name: 'Name',
    selector: (row) => row.name,
    sortable: true,
    cell: (row) => (
      <Text fontWeight={500} as="i">
        {row.name}
      </Text>
    ),
    sortField: 'name',
  },
  {
    name: 'Objective',
    selector: (row) => row.objective,
    wrap: true,
    sortable: true,
    format: (row) =>
      `${
        row.objective.length > 200
          ? `${removeHtmlTags(row.objective.slice(0, 200))}...`
          : removeHtmlTags(row.objective)
      }`,
    sortField: 'objective',
  },
  {
    name: 'Code',
    selector: (row) => row.code,
    sortable: true,
    cell: (row) => <Text>{row.code ?? 'N/A'}</Text>,
    sortField: 'code',
  },
  {
    name: 'Type',
    selector: (row) => row.code,
    sortable: false,
    cell: (row) => <Text fontWeight={500}>{row.type.name}</Text>,
    sortField: 'code',
  },
  {
    name: 'Status',
    selector: (row) => row.isPublished,
    sortable: true,
    cell: (row) => (
      <Tag size="sm" mt={2} colorScheme={row.isPublished ? 'green' : 'purple'}>
        <TagLeftIcon as={row.isPublished ? FaCheckCircle : FaPen} />
        <TagLabel>{row.isPublished ? 'Published' : 'Draft'}</TagLabel>
      </Tag>
    ),
    sortField: 'isPublished',
  },
  {
    name: 'Action',
    cell: (row) => (
      <LinkBox as={ReactRouterLink} to={`/admin/reports/sub-quests/${row.id}`}>
        <Button colorScheme="blue" size="sm">
          View
        </Button>
      </LinkBox>
    ),
  },
];
